import { PlanType } from './../../enums/user';

export class UserProfile {
  userId: number;
  externalUserId: string;
  fullName: string;
  displayTitle: string;
  emailId: string;
  planType: PlanType;
  roleId: number;
  landingPage: string;
  isSAML: boolean;
  lastUsedJurisdictionId: number;
  lastUsedJurisdictionName: string;

  constructor() {
    this.userId = 0;
    this.externalUserId = '';
    this.fullName = '';
    this.displayTitle = '';
    this.emailId = '';
    this.planType = PlanType.Basic;
    this.roleId = 0;
    this.landingPage = '';
    this.isSAML = false;
    this.lastUsedJurisdictionId = 0;
    this.lastUsedJurisdictionName =''
  }
}
